/* unplugin-vue-components disabled */import { render } from "./LoadingBuff.vue?vue&type=template&id=8b600732&scoped=true"
import script from "./LoadingBuff.vue?vue&type=script&lang=js"
export * from "./LoadingBuff.vue?vue&type=script&lang=js"

import "./LoadingBuff.vue?vue&type=style&index=0&id=8b600732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b600732"]])

export default __exports__